import { useEffect } from "react"
import { Container, Row, Col, Card, Form } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useAuth } from "../../components/auth/useAuth"
import { getSucursalSettings, updateSucursalSettings } from "../../actions/other/sucursalsActions"
import { RootState, AppDispatch } from "../../store"
import Swal from "sweetalert2"
import { Settings2 } from "lucide-react"

export default function Settings() {
    const { t } = useTranslation()
    const dispatch: AppDispatch = useDispatch()
    const { clientauth } = useAuth()

    const { settings, resultsuscursal } = useSelector((state: RootState) => state.sucursals)

    useEffect(() => {
        if (clientauth?.idSucursal) {
            dispatch(getSucursalSettings(clientauth.idSucursal) as any)
        }
    }, [clientauth])

    useEffect(() => {
        if (resultsuscursal === 'settingsUpdated') {
            dispatch({ type: 'SUCURSAL_RESET_RESULT' })
            Swal.fire({
                icon: 'success',
                confirmButtonText: t('global.great'),
                text: t('settingsTranslate.saveSuccess')
            })
        }
    }, [resultsuscursal])

    const handleToggle = (field: 'showHSP' | 'showComisiones') => {
        if (!clientauth?.idSucursal) return
        const updated = { ...settings, [field]: !settings[field] }
        dispatch(updateSucursalSettings(clientauth.idSucursal, updated) as any)
    }

    return (
        <Container fluid className="p-1 py-5 p-md-5">
            <Row>
                <Col xs={12} className="mb-4">
                    <h1>
                        <Settings2 size={28} className="me-2" />
                        {t('settingsTranslate.title')}
                    </h1>
                    <p className="text-muted">{t('settingsTranslate.subtitle')}</p>
                </Col>
            </Row>
            <Row>
                <Col xs={12} lg={8}>
                    <Card>
                        <Card.Body className="p-4">
                            <Row className="align-items-center py-3 border-bottom">
                                <Col xs={8}>
                                    <h5 className="mb-1">{t('settingsTranslate.showHSP')}</h5>
                                    <p className="text-muted mb-0 small">{t('settingsTranslate.showHSPDesc')}</p>
                                </Col>
                                <Col xs={4} className="text-end">
                                    <Form.Check
                                        type="switch"
                                        id="switch-hsp"
                                        checked={settings.showHSP}
                                        onChange={() => handleToggle('showHSP')}
                                        className="fs-4"
                                    />
                                </Col>
                            </Row>
                            <Row className="align-items-center py-3">
                                <Col xs={8}>
                                    <h5 className="mb-1">{t('settingsTranslate.showComisiones')}</h5>
                                    <p className="text-muted mb-0 small">{t('settingsTranslate.showComisionesDes')}</p>
                                </Col>
                                <Col xs={4} className="text-end">
                                    <Form.Check
                                        type="switch"
                                        id="switch-comisiones"
                                        checked={settings.showComisiones}
                                        onChange={() => handleToggle('showComisiones')}
                                        className="fs-4"
                                    />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}
